//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
let d=[[[0,"DialogViolationId",1,0],[0,"FilterOptionValue",1,0],[0,"NavigateViolationLocationOption",1,0],[0,"OverrideOptionValue",1,0],[0,"Username",1,0]],[[["numTextLines"],"GetOverrideText",{R_:{overrideText:""}},0,0],[["overrideText"],"SetOverrideText",{},1,0]],[]];
SPLM.Routing.DesignRuleViolationViewer = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.DesignRuleViolationViewer";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.DesignRuleViolationViewer.FilterOption = Object.freeze({
    "AllViolations" : "AllViolations", "SkipOverrides" : "SkipOverrides", "OverridesOnly" : "OverridesOnly"});

SPLM.Routing.DesignRuleViolationViewer.OverrideOption = Object.freeze({
    "Yes" : "Yes", "No" : "No"});

export default SPLM;